import { SelectizeSettings } from 'assets/js/SelectizePlugin-InfiniteScroll';

angular.module('logbook').directive('selectizeComponent', ['$http', '$q', '$timeout', '$rootScope', function($http, $q, $timeout, $rootScope)
{
	return {
		restrict: 'A',
		scope: {
			
			//Provide either an SelectizeSettings object or specify the 4 key types
			settings: '=?',
			
			//Function to watch for new settings object
			settingsWatch: '=',
			
			
			// Field that will be queried on when typing
			queryField: '@',
			
			// Endpoint used for querying from API
			entityType: '@',
			
			// Field that will be the value from the object
			valueField: '@',
			
			// Field that will be the displayed value from the object
			labelField: '@'
		},
		link: function(scope, element, attributes)
		{
			function build() {
				scope.selectizeSettings = scope.originalSettings =
					(scope.settings instanceof SelectizeSettings) ?
						scope.settings :
							(scope.options instanceof SelectizeSettings) ? 
								scope.options : 
								new SelectizeSettings(scope.entityType, scope.queryField)
									.setValueField(scope.valueField)
									.setLabelField(scope.labelField);
				
				scope.selectizeSettings.plugins = ['infinite_scroll', 'remove_button'];

				let logId = scope.selectizeSettings.getLogId() ||
					($rootScope.selectedLog ? $rootScope.selectedLog.id : 0);
				
				scope.selectizeSettings.setLogId(logId);
				
				scope.selectizeSettings.useLog(attributes.hasOwnProperty('useLog') || scope.selectizeSettings.useLog());
				scope.selectizeSettings.setValueField(scope.selectizeSettings.valueField || scope.valueField);
				scope.selectizeSettings.setLabelField(scope.selectizeSettings.labelField || scope.labelField);
				
				scope.selectizeSettings.load = function(query, callback)
				{
					try
					{
						query = JSON.parse(query);
						selectize.lastQuery = query;
						var options = scope.selectizeSettings.get$httpOptions();
						
						if (query.page > selectize.maxPages)
							return;
						
						options.params.page = query.page;
						
						var queryField = scope.selectizeSettings.getQueryField();
						
						if (queryField)
						{
							options.params[queryField] = scope.selectizeSettings.wrapWithWildCard(query.search);
						}
						
						if (scope.selectizeSettings.getLogId() > 0 && scope.selectizeSettings.useLog())
						{
							options.params.log = scope.selectizeSettings.getLogId();
						}
						
						$http.get(scope.selectizeSettings.getApiUrl(), scope.selectizeSettings.get$httpOptions())
							.then(function (results)
							{
								try
								{
									selectize.maxPages = results.data.page.totalPages;
									var results = scope.selectizeSettings.executeTransformer(results.data);
									scope.selectizeSettings.executePostTransformer();
									callback(results);
								} catch (e) {
									console.error('Selectize Transform Error', e);
									callback([])
								}
							}, function (error) {
								console.error(error);
								callback([])
							});
						
					} catch (e)
					{
						console.error('Selectize Fetch Error', e);
						callback([]);
					}
				};
				
				scope.selectizeSettings.setSearchField(scope.selectizeSettings.getSearchField());
				
				if (scope.instance)
					scope.instance.destroy();
				
				var selectize = $(element).selectize(scope.selectizeSettings)[0].selectize;
				scope.instance = scope.selectizeSettings.instance = selectize;
				
				/**
				 * Adds a list of options to the selectize instance and selects the items based on the valueField set.
				 * @param {[]} options
				 * @param {Boolean=true} silent - Whether using this function should trigger onChange functions to execute.
				 */
				selectize.addAndSelectOptions = function(options, silent)
				{
					silent = (typeof silent === 'boolean') ? silent : true;
					options = (Array.isArray(options)) ? options : [options];
					
					selectize.addOption(options);
					selectize.addItems(options.map(function(item) { return item[scope.selectizeSettings.getValueField()] }), silent);
				};
				
				if (scope.originalSettings instanceof SelectizeSettings)
				{
					scope.originalSettings.instances.push({ element: element, instance: selectize });
					scope.originalSettings.executeInstanceCallback(selectize);
				}
			}
			
			
			// Removes Selectize Instance from Options instances if scope is destroyed.
			scope.$on('$destroy', function()
			{
				var index = scope.selectizeSettings.instances.findIndex(function(instance) { return instance.instance === scope.instance });
				
				if (index > -1)
					scope.selectizeSettings.instances.splice(index, 1);
			});
			
			if (typeof scope.settingsWatch === 'function')
				scope.$watch(scope.settingsWatch, function(newVal)
				{
					if (newVal instanceof SelectizeSettings)
					{
						scope.settings = newVal;
						build();
					}
				})
			
			build();
		}
	}
}]);